/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Type/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Type({
  children,
  viewPath = "/App/Account/WaitingRoom/Content/Content/Checkout/Appointments/Content/Appointment/Type"
  
}) {
let appointmentBookingAppointmentTypeFullNameValueData = fromData.useDataValue({ viewPath,
context: 'appointment_booking',
path: 'appointment_type.full_name',
})
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 cursor="pointer"
 size="small"
 overflow="hidden"
 whiteSpace="nowrap"
 textOverflow="ellipsis"
 color={dtColorsNeutral700}
 data="appointment_booking.appointment_type.full_name"
 text={appointmentBookingAppointmentTypeFullNameValueData}
/>
{children}
</React.Fragment>)
}